import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getContractsNew,
  getContractNewById,
  createContractNew,
  updateContractNew,
  submitContract,
  approveContract,
  rejectContract,
  activateContract,
  terminateContract,
  deleteContract,
  amendContract,
  addContractUnits,
  getContractCosts,
  addContractCosts,
  updateContractCost,
  deleteContractCost,
  setRevenueScheme,
  addContractParties,
  updateContractParty,
  deleteContractParty,
  getContractVersions,
  getContractServices,
  setContractServices,
  getServiceUnits,
  addServiceUnit,
  removeServiceUnit,
  getCostPeriods,
  createCostPeriod,
  updateCostPeriod,
  deleteCostPeriod,
  getPeriodCosts,
  addPeriodCost,
  updatePeriodCost,
  deletePeriodCost,
  getCostUnits,
  addCostUnit,
  updateCostUnit,
  deleteCostUnit,
} from "libs/api/contract_new";

export const getContractsNewThunk = createAsyncThunk(
  "contractNew/getContracts",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, queryParams }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getContractsNew(queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const getContractNewByIdThunk = createAsyncThunk(
  "contractNew/getContractById",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getContractNewById(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const createContractNewThunk = createAsyncThunk(
  "contractNew/createContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createContractNew(body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const updateContractNewThunk = createAsyncThunk(
  "contractNew/updateContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateContractNew(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const submitContractThunk = createAsyncThunk(
  "contractNew/submitContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await submitContract(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const approveContractThunk = createAsyncThunk(
  "contractNew/approveContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await approveContract(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const rejectContractThunk = createAsyncThunk(
  "contractNew/rejectContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await rejectContract(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const activateContractThunk = createAsyncThunk(
  "contractNew/activateContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await activateContract(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const terminateContractThunk = createAsyncThunk(
  "contractNew/terminateContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await terminateContract(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const deleteContractThunk = createAsyncThunk(
  "contractNew/deleteContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteContract(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const amendContractThunk = createAsyncThunk(
  "contractNew/amendContract",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await amendContract(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const addContractUnitsThunk = createAsyncThunk(
  "contractNew/addUnits",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await addContractUnits(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const getContractCostsThunk = createAsyncThunk(
  "contractNew/getContractCosts",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getContractCosts(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const addContractCostsThunk = createAsyncThunk(
  "contractNew/addCosts",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await addContractCosts(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const updateContractCostThunk = createAsyncThunk(
  "contractNew/updateCost",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, costId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateContractCost(id, costId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const deleteContractCostThunk = createAsyncThunk(
  "contractNew/deleteCost",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, costId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteContractCost(id, costId);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const setRevenueSchemeThunk = createAsyncThunk(
  "contractNew/setRevenueScheme",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await setRevenueScheme(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const addContractPartiesThunk = createAsyncThunk(
  "contractNew/addParties",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await addContractParties(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const updateContractPartyThunk = createAsyncThunk(
  "contractNew/updateParty",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, partyId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateContractParty(id, partyId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const deleteContractPartyThunk = createAsyncThunk(
  "contractNew/deleteParty",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, partyId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteContractParty(id, partyId);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const getContractVersionsThunk = createAsyncThunk(
  "contractNew/getVersions",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getContractVersions(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const getContractServicesThunk = createAsyncThunk(
  "contractNew/getServices",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getContractServices(id);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const setContractServicesThunk = createAsyncThunk(
  "contractNew/setServices",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await setContractServices(id, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// ── ServiceUnit Thunks ────────────────────────────────────
export const getServiceUnitsThunk = createAsyncThunk(
  "contractNew/getServiceUnits",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, contractId, serviceId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getServiceUnits(contractId, serviceId);
      typeof cbFulfilled === "function" && cbFulfilled(response?.data);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const addServiceUnitThunk = createAsyncThunk(
  "contractNew/addServiceUnit",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, contractId, serviceId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await addServiceUnit(contractId, serviceId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const removeServiceUnitThunk = createAsyncThunk(
  "contractNew/removeServiceUnit",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, contractId, serviceId, unitId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await removeServiceUnit(contractId, serviceId, unitId);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// ── ContractCostPeriod Thunks ─────────────────────────────
export const getCostPeriodsThunk = createAsyncThunk(
  "contractNew/getCostPeriods",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, contractId, serviceId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getCostPeriods(contractId, serviceId);
      typeof cbFulfilled === "function" && cbFulfilled(response?.data);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const createCostPeriodThunk = createAsyncThunk(
  "contractNew/createCostPeriod",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, contractId, serviceId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createCostPeriod(contractId, serviceId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const updateCostPeriodThunk = createAsyncThunk(
  "contractNew/updateCostPeriod",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, contractId, serviceId, periodId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateCostPeriod(contractId, serviceId, periodId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const deleteCostPeriodThunk = createAsyncThunk(
  "contractNew/deleteCostPeriod",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, contractId, serviceId, periodId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteCostPeriod(contractId, serviceId, periodId);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// ── ContractCost (under period) Thunks ───────────────────
export const getPeriodCostsThunk = createAsyncThunk(
  "contractNew/getPeriodCosts",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, periodId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getPeriodCosts(periodId);
      typeof cbFulfilled === "function" && cbFulfilled(response?.data);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const addPeriodCostThunk = createAsyncThunk(
  "contractNew/addPeriodCost",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, periodId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await addPeriodCost(periodId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const updatePeriodCostThunk = createAsyncThunk(
  "contractNew/updatePeriodCost",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, costId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updatePeriodCost(costId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const deletePeriodCostThunk = createAsyncThunk(
  "contractNew/deletePeriodCost",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, costId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deletePeriodCost(costId);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// ── ContractCostUnit Thunks ───────────────────────────────
export const getCostUnitsThunk = createAsyncThunk(
  "contractNew/getCostUnits",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, costId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getCostUnits(costId);
      typeof cbFulfilled === "function" && cbFulfilled(response?.data);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const addCostUnitThunk = createAsyncThunk(
  "contractNew/addCostUnit",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, costId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await addCostUnit(costId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const updateCostUnitThunk = createAsyncThunk(
  "contractNew/updateCostUnit",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, costId, unitId, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateCostUnit(costId, unitId, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const deleteCostUnitThunk = createAsyncThunk(
  "contractNew/deleteCostUnit",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, costId, unitId }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteCostUnit(costId, unitId);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
